function ArrowControls (Glide) {
  const CLASSES = Glide.settings.arrowClasses;
  const GLIDE_PARENT = document.querySelector(Glide.selector).parentNode.parentNode;
  const BACK_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.back);
  const NEXT_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.next);

  return {
    mount() {
      BACK_ARROW.addEventListener('click', function() { Glide.go('<'); });
      NEXT_ARROW.addEventListener('click', function() { Glide.go('>'); });
    }
  }
}

function ArrowDisabler (Glide, Components) {
  const CLASSES = Glide.settings.arrowClasses;
  const GLIDE_PARENT = document.querySelector(Glide.selector).parentNode.parentNode;
  const BACK_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.back);
  const NEXT_ARROW = GLIDE_PARENT.querySelector('.' + CLASSES.next);

  return {
    mount() {
      if (Glide.settings.rewind) {
        return;
      }

      Glide.on(['mount.after', 'run', 'resize'], () => {
        const lastSlideIndex = Glide.settings.bound ? Glide.index + (Glide.settings.perView - 1) : Glide.index;
        const isLastSlide = lastSlideIndex === Components.Sizes.length - 1;
        const isFirstSlide = Glide.index === 0;
        const notEnoughSlides = Components.Sizes.length <= Glide.settings.perView;

        isFirstSlide ? BACK_ARROW.classList.add(CLASSES.disabled) : BACK_ARROW.classList.remove(CLASSES.disabled);
        isLastSlide || notEnoughSlides ? NEXT_ARROW.classList.add(CLASSES.disabled) : NEXT_ARROW.classList.remove(CLASSES.disabled);
      });
    }
  }
}

function ArrowResizer (Glide, Components) {
  return {
    mount() {
      Glide.on(['mount.after', 'resize'], () => {
        Components.Sizes.length <= Glide.settings.perView ? Glide.disable() : Glide.enable()
      });
    }
  }
}

function BulletsControl (Glide, Components) {
  const BULLET_WRAPPER_CLASSES = Glide.settings.bulletWrapper;
  const BULLET_CLASS = Glide.settings.bulletClass;
  const BULLET_ACTIVE_CLASS = BULLET_CLASS.substr(1) + '--active';
  const BULLET_WRAPPER = document.querySelector(BULLET_WRAPPER_CLASSES);
  const BULLETS = BULLET_WRAPPER.querySelectorAll(BULLET_CLASS);

  const getIndex = event => event.currentTarget.getAttribute('data-slide-index');
  const setActiveBullet = index => document.querySelector(`[data-slide-index="${index}"]`).classList.add(BULLET_ACTIVE_CLASS);
  const removeActiveBullet = () => BULLET_WRAPPER.querySelector('.' + BULLET_ACTIVE_CLASS).classList.remove(BULLET_ACTIVE_CLASS);
  const removeFocus = event => event.currentTarget.blur();

  Glide.on(['run'], () => {
    removeActiveBullet();
    setActiveBullet(Glide.index);
  });

  return {
    mount() {
      for (let i = 0; i < BULLETS.length; i++) {
        const BULLET = BULLETS[i];

        BULLET.addEventListener('click', event => {
          Glide.go(`=${getIndex(event)}`);
          removeFocus(event);
        });
      }
    }
  }
}

module.exports = { ArrowControls, ArrowDisabler, ArrowResizer, BulletsControl }
